module.exports = __webpack_public_path__ + "img/kirinsushifrontmicroview.eabc43ad.jpg";